export const booleanSorter = (a: boolean, b: boolean) => (a === b ? 0 : a ? -1 : 1);

export const stringSorter = (a: string, b: string) => a.localeCompare(b);

export const dateSorter = (a: string | null, b: string | null) =>
  new Date(b as string).getTime() - new Date(a as string).getTime();
